import { Seconds } from '@mi-front/core';
import { Duration } from '@ui/components';

type PersonsViewDurationCellProps = {
  ms: number;
};

/**
 * Duration column cell in the Personas results table (on-screen / speaking).
 *
 * Shows a formatted duration for the given milliseconds, or an em dash when
 * the person has no time in that source.
 */
export function PersonsViewDurationCell({ ms }: PersonsViewDurationCellProps) {
  return ms > 0 ? <Duration seconds={(ms / 1000) as Seconds} /> : <span>—</span>;
}
